import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-four-lesson-two-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFourLessonTwoGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 4, Lesson 2 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 2: Writing a R\xE9sum\xE9";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
